module.exports = __webpack_public_path__ + "static/header-events-7ae3416516efb2b7f5b7b6018ecc0668.jpg";